export function addInlineStyles(html: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    doc.querySelectorAll('table').forEach(table => {
      if (!table.style.tableLayout) table.style.tableLayout = 'fixed';
      if (!table.style.borderCollapse) table.style.borderCollapse = 'collapse';
    });

    doc.querySelectorAll('td').forEach(td => {
      if (!td.style.border) td.style.border = '1px solid #000';
      if (!td.style.padding) td.style.padding = '2px 5px';
      if (!td.style.outline) td.style.outline = 'none';
      if (!td.style.wordBreak) td.style.wordBreak = 'break-all';
    });

    doc.querySelectorAll('p').forEach(p => {
        if (!p.style.margin) p.style.margin = '0px';
    });

    return doc.body.innerHTML;
}
